<template>
  <div>
    <div class="goodslist">
      <div class="goodslist_top">
        <div class="goodslist_title">筛选查询</div>
        <div class="goodslost_seach">
          <el-row class="goodslost_seach_row">
            <el-col :span="7">
              <div class="goodslost_seach_row_col">
                <div>商品名称:</div>
                <el-input placeholder="商品名称" v-model="name" clearable  style="width:190px" size="mini"></el-input>
              </div>
            </el-col>
            <el-col :span="7">
              <div class="goodslost_seach_row_col">
                <div>商品货号:</div>
                <el-input placeholder="商品货号" v-model="item_no" clearable  style="width:190px" size="mini"></el-input>
              </div>
            </el-col>
           
            <el-col :span="6">
              <div class="goodslost_seach_row_col">
                <div>商品分类:</div>
                <!-- @change="changeoptin" -->
                <el-select size="mini" v-model="value" clearable  placeholder="请选择分类">
                  <el-option
                    v-for="item in options"
                    :key="item.id"
                    :label="item.cate_name"
                    :value="item.cate_name"
                  ></el-option>
                </el-select>
              </div>
            </el-col>
             <el-col :span="6">
              <div class="goodslost_seach_row_col" style="margin-top:10px">
                <div>状态:</div>
                <!-- @change="changeoptin" -->
                <el-select size="mini" v-model="status" clearable  placeholder="请选择状态">
                  <el-option
                    v-for="item in statuslist"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </div>
            </el-col>
            <el-col :span="4" style="text-align:center;margin-top:10px">
              <div>
                <el-button size="mini" @click="seach()">搜索</el-button>
                <el-button size="mini" @click="change_null">清空</el-button>
              </div>
            </el-col>
          </el-row>
        </div>
      </div>
      <div class="goodslist_bom goodslist_top">
        <div class="goodslist_title">
          <div>
            <i class="iconfont icon-liebiao" style="color:#666"></i> 数据列表
          </div>
          <div class="show_total">
            <el-dropdown trigger="click" @command="change_page_num">
              <span class="el-dropdown-link">
                显示条数
                <i style="font-size: 12px;" class="iconfont icon-sanjiaoxing"></i>
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item :command="10">每页10条</el-dropdown-item>
                <el-dropdown-item :command="15">每页15条</el-dropdown-item>
                <el-dropdown-item :command="20">每页20条</el-dropdown-item>
                <el-dropdown-item :command="50">每页50条</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
        </div>
        <div class="goodslist_bom_border">
          <el-table
            :header-cell-style="{
             'background':'#F5FAF9'
          }"
            v-loading="loading"
            :data="tableData"
            border
            style="width: 100%"
          >
            <el-table-column align="center"  prop="id" label="编号" width="80"></el-table-column>
            <el-table-column
              align="center"
              prop="title"
              label="商品名称"
              width="180"
              show-overflow-tooltip
            ></el-table-column>
            <el-table-column align="center" prop="selling_price" label="价格"></el-table-column>
            <el-table-column align="center" prop="item_no" label="货号" show-overflow-tooltip></el-table-column>
            <el-table-column align="center" prop="top_class" label="分类" show-overflow-tooltip></el-table-column>
            <el-table-column align="center" prop="specification" label="规格" show-overflow-tooltip></el-table-column>
            <el-table-column align="center" label="驳回原因" show-overflow-tooltip>
                <template slot-scope="scope">
                <span v-if="scope.row.check == 2">{{scope.row.check_reson}}</span>
                <span type="info" size="small" v-else>-</span>
              </template>
            </el-table-column>
            <el-table-column align="center" label="状态" show-overflow-tooltip>
              <template slot-scope="scope">
                <!-- <span>{{scope.row.check == 0 ? '未审核' : '已审核'}}</span> -->
                <el-tag  v-if="scope.row.check == 1" size="small" type="success">已审核</el-tag>
                <el-tag  v-else-if="scope.row.check == 2" size="small" type="danger">被驳回</el-tag>
                <el-tag type="info" size="small" v-else>待审核</el-tag>
              </template>
            </el-table-column>
            <el-table-column width="120" align="center" label="操作">
              <template slot-scope="scope">
                <span class="binaji" v-if="scope.row.check ==1" @click="setgoods(scope.row.id)">编辑</span>
                <span class="binaji" v-if="scope.row.check ==0 || scope.row.check ==2" @click="setgoods(scope.row.id)">编辑</span>
                <span class="binaji" v-if="scope.row.check ==0" @click="goodsdelete(scope.row.id)">删除</span>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div>
          <el-pagination
            class="goodslist_bom_page"
            hide-on-single-page
            background
            layout="total,prev, pager, next"
            :page-size="limit"
            :total="total"
            @current-change="pagechange"
          ></el-pagination>
          <!-- hide-on-single-page -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      loading: false,
      name: "",
      item_no: "",
      options: [],
      tableData: [],
      value: "",
      token: this.$cookies.get("shop_token"),
      page: null,
      total: null,
      limit: 15,
      status: this.$route.query.status && this.$route.query.status == 3 ? 0 : "",
      statuslist: [
        
        { label: "未审核", value: 0 },
        { label: "已审核", value: 1 },
        { label: "被驳回", value: 2 },
      ],
    };
  },
  created() {
    this.$store.state.shop_top = 1;
    this.$store.state.shop_left = "商品列表";
    this.axios
      .get(this.$store.state.serve + "shop/get_cate_name", {
        params: {
          token: this.token
        }
      })
      .then(res => {
        if (res.data.status == "success") {
          this.options = res.data.data;
        }
      });
    this.geting();
  },
  methods: {
    setgoods(id) {
      this.$router.push("/shop/setgoods?id=" + id);
    },
    change_page_num(e) {
      this.limit = e;
      this.geting();
    },
    //   changeoptin(){
    //   },
    pagechange(page) {
      this.geting(page);
    },
    geting(page) {
      this.loading = true;
      this.axios
        .get(this.$store.state.serve + "shop/product_list", {
          params: {
            token: this.token,
            page,
            limit: this.limit,
            name: this.name,
            item_no: this.item_no,
            topClass: this.value,
            status: this.status
          }
        })
        .then(res => {
          var json = res.data.data;
          if (res.data.status == "success") {
            this.tableData = json.results;
            this.page = json.page;
            this.total = json.total;
            this.loading = false;
          } else {
            this.loading = false;
          }
        });
    },
    goodsdelete(id) {
      this.$confirm("此操作将删除该商品, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          //  this.$message({
          //    type: "success",
          //    message: "删除成功!"
          //  });
          this.axios
            .get(this.$store.state.serve + "shop/delProduct", {
              params: {
                token: this.token,
                id
              }
            })
            .then(res => {
              if (res.data.status == "success") {
                this.$alerts.success(res.data.msg, this.$message);
                this.geting();
              } else {
                this.$alerts.error(res.data.msg, this.$message);
                this.geting();
              }
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除"
          });
        });
    },
    change_null() {
      (this.value = ""), (this.name = ""), (this.item_no = ""),(this.status = "");
      this.geting();
    },
    seach() {
      this.geting();
    }
  }
};
</script>

<style lang="scss">
.goodslist {
  .goodslist_top {
    border: 1px solid rgba(221, 221, 221, 1);
    .goodslist_title {
      border-bottom: 1px solid rgba(221, 221, 221, 1);
      width: 1028px;
      height: 46px;
      background: rgba(238, 238, 238, 1);
      font-size: 16px;
      font-family: "Microsoft YaHei";
      font-weight: 400;
      color: #333;
      line-height: 46px;
      padding-left: 16px;
      display: flex;
      justify-content: space-between;
      padding-right: 16px;
      align-items: center;
      .show_total {
        color: rgba(153, 153, 153, 1);
        font-size: 12px;
        width: 100px;
        height: 30px;
        background: rgba(255, 255, 255, 1);
        border: 1px solid rgba(221, 221, 221, 1);
        text-align: center;
        cursor: pointer;
        line-height: 30px;
      }
    }
    .goodslost_seach {
      // width: 1060px;
      // line-height: 86px;
      font-size: 16px;
      font-family: "Microsoft YaHei";
      font-weight: 300;
      color: rgba(51, 51, 51, 1);
      height: 86px;
      background: rgba(255, 255, 255, 1);
      display: flex;
      align-items: center;
      .goodslost_seach_row {
        width: 100%;
        .goodslost_seach_row_col {
          display: flex;
          align-items: center;
          justify-content: space-evenly;
        }
      }
    }
  }
  .goodslist_bom {
    margin-top: 19px;
    margin-bottom: 100px;
    .binaji {
      cursor: pointer;
      margin-right: 10px;
      margin-left: 10px;
      font-weight: 300;
      font-size: 14px;
      color: rgba(51, 51, 51, 1);
      line-height: 18px;
    }
    .binaji:hover {
      color: #0099ff;
    }
    .goodslist_bom_page {
      //  height: 80px;
      padding: 13px 0 30px 0;
      text-align: right;
    }
  }
}
</style>